import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Oct 2026 — bill line-item text guard. The invoice agent has shipped
// `description`/`hsn` as {"value": "...", "source": "agent+ocr"} objects;
// rendering one as a JSX child (or binding it to an input) crashes the
// page. Coerce to a plain string at render/hydration time; the backend
// validator on RMInwardBillCreate keeps NEW writes clean.
export function asText(v) {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (typeof v === "object" && typeof v.value === "string") return v.value;
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  return "";
}
